// extracted by mini-css-extract-plugin
export default {"servicecase":"services_case_servicecase__XZnGx","overlay":"services_case_overlay__xQo9n","services_cases__wrapper":"services_case_services_cases__wrapper__2piY+"};